<div class="modern-header-section">
  <div class="modern-header-content">
    <div class="header-title-container">
      <!-- Optional icon left of the title (CHAT-1155: the channel's own icon). -->
      <ng-content select="[pageHeaderIcon]"></ng-content>
      <h1 class="page-header-title">
        <ng-container *ngIf="parentLabel && parentLink">
          <a class="page-header-parent" [routerLink]="parentLink">{{ parentLabel }}</a>
          <span class="page-header-separator" aria-hidden="true"> / </span>
        </ng-container>{{ title }}
      </h1>
      <div class="help-tooltip-container" *ngIf="helpText || resolvedHelpUrl">
        <span class="help-tooltip-icon">
          <i class="fa fa-question-circle"></i>
        </span>
        <div class="help-tooltip-content">
          <div *ngIf="helpText" class="help-description">{{ helpText }}</div>
          <a
            *ngIf="!isLoadingHelp && resolvedHelpUrl"
            class="help-link"
            [href]="resolvedHelpUrl"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i class="fa fa-external-link-alt"></i> Learn more
          </a>
        </div>
      </div>
    </div>
    <p class="modern-step-subtitle" *ngIf="subtitle">{{ subtitle }}</p>
  </div>
  <div class="modern-header-actions">
    <ng-content></ng-content>
  </div>
</div>
